import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import {
  ComparatorBanner,
  ComparatorBannerDescription,
  ComparatorBannerHeader,
  ComparatorBannerTitle,
  ComparatorClear,
  ComparatorGrid,
  ComparatorGridColumn,
  ComparatorModeTrigger,
  ComparatorScroller,
  ComparatorSelectedItem,
  ComparatorSelectionList,
} from "@tudigo-monorepo/web-tudigo-comparator";
import {
  UI_PROJECTS_COMPARATOR_MODAL_OPENED,
  UI_PROJECTS_COMPARATOR_SELECTION_PROJECT_DELETED,
  UI_PROJECTS_COMPARATOR_STARTED,
} from "@tudigo-monorepo/web-tudigo-tracking";

import {
  ProjectCard,
  ProjectCardAvatar,
  ProjectCardAvatarFallback,
  ProjectCardHeader,
  ProjectCardLabel,
} from "../../../../shared-external/components/project-card/project-card";
import { useProjectsComparatorCustomerTracking } from "../../hooks/use-projects-comparator-customer-tracking";

export function ProjectsComparatorSelectionBanner() {
  const { comparatorStatePayload, customerTrackComparator } =
    useProjectsComparatorCustomerTracking();

  return (
    <ComparatorBanner className="fixed bottom-0 w-screen">
      <ComparatorBannerHeader>
        <ComparatorBannerTitle>Comparatif de projets</ComparatorBannerTitle>
        <div className="flex w-full items-center gap-3 sm:w-fit">
          <ComparatorClear className="hidden sm:flex sm:w-fit" />
          <ComparatorModeTrigger
            className="bg-accent hover:bg-accent sm:bg-accent-super-light-rebrand sm:ring-accent sm:text-accent w-full text-white ring-0 sm:w-fit sm:ring-[3px] sm:hover:bg-inherit"
            iconClassName="sm:text-accent text-white"
            onUpdate={(mode) => {
              if (mode === "selection") {
                customerTrackComparator(UI_PROJECTS_COMPARATOR_STARTED);
              }
              if (mode === "comparison") {
                customerTrackComparator(
                  UI_PROJECTS_COMPARATOR_MODAL_OPENED,
                  comparatorStatePayload,
                );
              }
            }}
          />
        </div>
      </ComparatorBannerHeader>
      <ComparatorBannerDescription className="hidden sm:block">
        Veuillez sélectionner les opportunités que vous souhaitez comparer dans
        la liste plus haut
      </ComparatorBannerDescription>

      <ComparatorScroller
        className="mb-6 hidden sm:flex"
        scrollableItemWidth={240}
        scrollButtonsPositionType="floating"
        maxScrollWidthDisabled
      >
        <ComparatorGrid className="ml-4 lg:gap-x-4">
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorGridColumn key={project.id}>
                <ComparatorSelectedItem
                  item={project}
                  className="h-20 lg:min-w-60 lg:max-w-60"
                  onUpdate={() => {
                    customerTrackComparator(
                      UI_PROJECTS_COMPARATOR_SELECTION_PROJECT_DELETED,
                      {
                        project_id: project.id,
                        project_name: project.content?.name,
                      },
                    );
                  }}
                >
                  <ProjectCard
                    project={project}
                    className="h-full shadow-[0_1px_10px_0_rgba(87,87,80,0.05)]"
                  >
                    <ProjectCardHeader className="mb-0 h-full w-full rounded-b-lg bg-white py-[25px] pl-4">
                      <ProjectCardAvatar />
                      <ProjectCardAvatarFallback />
                      <ProjectCardLabel className="max-w-28 text-base font-medium" />
                    </ProjectCardHeader>
                  </ProjectCard>
                </ComparatorSelectedItem>
              </ComparatorGridColumn>
            )}
          </ComparatorSelectionList>
          <div className="w-px" />
        </ComparatorGrid>
      </ComparatorScroller>
    </ComparatorBanner>
  );
}
